import type { EntityStateEvents } from 'shared/channels/entity';
import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type {
  DirectoriesBatchCreatedModel,
  DirectoriesBatchCreateModel,
  DirectoryCreateModel,
  DirectoryEditModel,
  DirectoryModel,
} from './directoryModel';

/** `uploadedEntity`: a directory the server created. */
export interface UploadedDirectoryPayload {
  localId?: number;
  _id?: string;
  name?: string;
  parentId?: string;
}

export interface BreadcrumbItem {
  _id: string;
  name: string;
}

/** Directory requests answered by the service worker and the events it broadcasts. */
export const directoryContract = defineChannelContract<{
  requests: {
    getChildren: { request: { parentId: string }; response: DirectoryModel[] };
    getAll: { request: undefined; response: DirectoryModel[] };
    getBreadcrumbs: { request: { directoryId: string }; response: BreadcrumbItem[] };
    create: { request: { directory: DirectoryCreateModel; uniqueId: string }; response: void };
    /** The result follows as `directoriesBatchCreated`, once the server created them. */
    createBatch: { request: { directories: DirectoriesBatchCreateModel; uniqueId: string }; response: void };
    edit: { request: { directory: DirectoryEditModel; uniqueId: string }; response: void };
    sync: { request: undefined; response: void };
  };
  events: EntityStateEvents & {
    [DomainMessagesTypes.directoriesBatchCreated]: DirectoriesBatchCreatedModel;
    [DomainMessagesTypes.createdEntity]: unknown;
    [DomainMessagesTypes.uploadedEntity]: UploadedDirectoryPayload;
    [DomainMessagesTypes.updatedEntity]: unknown;
    [DomainMessagesTypes.documentationMoved]: unknown;
    [DomainMessagesTypes.documentationDeleted]: unknown;
    [DomainMessagesTypes.documentationRestored]: unknown;
    [DomainMessagesTypes.allDirectories]: unknown;
  };
}>('directoryChannel');
